import "../theme/Instructions.css";
import "../theme/Utilities.css";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { Granted, Permissions } from "../components/scan/Permissions";
import PoseOverlay from "../components/scan/PoseOverlay";
import { CaptureScreen } from "../design-system/shell/capture-screen";
import { ActionButton } from "../design-system/concept/action-button";
import { CameraIcon } from "../design-system/shell/icons";

const SidePosePage: React.FC = () => {
  const history = useHistory();
  const { profileID, sessionID, gender } = useParams<{
    profileID: string;
    sessionID: string;
    gender: string;
  }>();
  const [permission, setPermission] = useState(false);
  useEffect(() => {}, [permission]);

  return (
    <CaptureScreen>
      <Permissions updated={(granted: Granted) => setPermission(granted.gyro)} />
      {permission && (
        <div className="flex flex-1 flex-col items-center justify-center gap-8 p-6">
          <PoseOverlay view="side" />
          <ActionButton
            variant="primary"
            className="flex items-center gap-2 px-6 py-3 text-sm"
            onClick={() =>
              history.push(`/photo/${profileID}/${sessionID}/${gender}/side`)
            }
          >
            <span className="flex items-center gap-2">
              Open camera <CameraIcon size={18} />
            </span>
          </ActionButton>
        </div>
      )}
    </CaptureScreen>
  );
};

export default SidePosePage;
